
export default function (props){
    if((process.env.REACT_APP_ENVIRONMENT).toLowerCase() !== "production") {
        return (props.prereleaseComponent);
    }else {
        return null
    }
}
